import * as React from "react";
import * as queryString from "query-string";
import ResetPassword from "modules/account/components/pages/ResetPassword";
import VerifyEmail from "modules/account/components/pages/VerifyEmail";

class ResetAndVerify extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }

  handleQuery = () => {
    const values = queryString.parse(this.props.location.search);
    return values.mode;
  };

  render() {
    return queryString.parse(this.props.location.search).mode ===
      "verifyEmail" ? (
      <VerifyEmail />
    ) : (
      <ResetPassword />
    );
  }
}

export default ResetAndVerify;



// WEBPACK FOOTER //
// ./src/modules/account/components/pages/ResetAndVerify.tsx